import styled from '@emotion/styled';

export const Wrapper = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral[100]};
  }
`;

// rgba(255, 255, 255, 0.04)
